import { render, staticRenderFns } from "./CardCommSupporter.vue?vue&type=template&id=345e0107&scoped=true&"
import script from "./CardCommSupporter.vue?vue&type=script&lang=js&"
export * from "./CardCommSupporter.vue?vue&type=script&lang=js&"
import style0 from "./CardCommSupporter.vue?vue&type=style&index=0&id=345e0107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e0107",
  null
  
)

export default component.exports